
import { instantiate } from './DiWAN3-kzApp.uninstantiated.mjs';


const exports = (await instantiate({
})).exports;

export const {
memory,
_initialize
} = exports


